import React from 'react';
import { Tag } from 'antd';

import PriceFees from '../../../components/PriceFees.jsx';
import { formatMoney, formatUnits } from '../../../format';
import { fundName } from './register.js';

const dash = (value, format = (v) => v) => (value === null || value === undefined || value === '' ? '—' : format(value));

/**
 * The register's fund cards (GET register/funds; IP-112): one per fund, with
 * the Core's units in issue, the latest published NAV per unit and its
 * dealing date, the fund's NAV (units x NAV per unit, the API's own figure),
 * the selling, buying and buying-with-exit-fee prices and the selling price
 * with the front-end fee (IP-179), and how many holders
 * hold units. A fund with no published price yet says so rather than show a
 * zero, and leaves the three dealing prices off. Closed funds stay, with
 * their status. Selecting a card drills the register into that fund;
 * selecting it again goes back to every fund.
 *
 * The same price-card frame Unit Prices used (registry.css price-card).
 * Figures arrive as decimal strings and are shown as format.js shows them.
 * Where a price came from is left to Price History.
 */
const FundSummaryCards = ({ funds, selectedFundId, onSelect }) => (
    <div className="price-card-grid">
        {funds.map((fund) => {
            const isSelected = fund.fundId === selectedFundId;
            const price = fund.price ?? null;
            return (
                <button
                    type="button"
                    key={fund.fundId}
                    className={`price-card fund-card register-fund-card${isSelected ? ' is-selected' : ''}`}
                    aria-pressed={isSelected}
                    // Clicking the selected card again clears the drill-down.
                    onClick={() => onSelect(isSelected ? null : fund.fundId)}
                >
                    <div className="price-card-body">
                        <div className="price-card-code">
                            {fund.fundId}
                            {fund.status && fund.status !== 'ACTIVE' && <Tag className="register-fund-status">{fund.status}</Tag>}
                        </div>
                        <div className="price-card-name">{fundName(fund)}</div>
                        <div className="price-card-figure">
                            <div className="price-card-nav">{formatUnits(fund.unitsInIssue)}</div>
                            <div className="price-card-caption">Units in issue</div>
                        </div>
                        <div className="price-card-prices">
                            <dl className="price-card-pair">
                                <div>
                                    <dt>NAV (LKR)</dt>
                                    <dd className="is-nav">{fund.nav === null || fund.nav === undefined ? '—' : formatMoney(fund.nav)}</dd>
                                </div>
                                <div>
                                    <dt>NAV per unit</dt>
                                    <dd className="is-nav-per-unit">{price ? formatUnits(price.navPerUnit) : '—'}</dd>
                                </div>
                            </dl>
                            {price && (
                                <>
                                    <dl className="price-card-pair">
                                        <div><dt>Selling</dt><dd className="is-selling">{dash(price.sellingPrice, formatUnits)}</dd></div>
                                        <div><dt>Buying</dt><dd className="is-buying">{dash(price.buyingPrice, formatUnits)}</dd></div>
                                    </dl>
                                    <PriceFees price={price} />
                                </>
                            )}
                            <div className="register-fund-foot">
                                {price ? 'Priced ' + price.dealingDate : 'No published price yet'}
                                {' - '}
                                {fund.holderCount ?? 0} holder{fund.holderCount === 1 ? '' : 's'} with units
                            </div>
                        </div>
                    </div>
                </button>
            );
        })}
    </div>
);

export default FundSummaryCards;
